module.exports = __webpack_public_path__ + "img/product-7.21abc583.png";